import { render, staticRenderFns } from "./AdviserSectionHeading.vue?vue&type=template&id=4386d1cf&scoped=true"
import script from "./AdviserSectionHeading.vue?vue&type=script&lang=js"
export * from "./AdviserSectionHeading.vue?vue&type=script&lang=js"
import style0 from "./AdviserSectionHeading.vue?vue&type=style&index=0&id=4386d1cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4386d1cf",
  null
  
)

export default component.exports